/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - Общие принципы мемоизации</h2>
    <p className={styles.description}>
      <b>Мемоизация</b> — сохранение (кеширование) результатов выполнения функций для предотвращения повторных
      вычислений. Это один из способов оптимизации, применяемый для увеличения скорости выполнения компьютерных
      программ.
    </p>
    <p className={styles.description}>
      Проще говоря, мемоизация — это запоминание, сохранение чего-либо в памяти. Функции, в которых используется
      мемоизация, обычно работают быстрее, так как при их повторных вызовах с одними и теми же аргументами, они, вместо
      выполнения вычислений, просто считывают результаты из кэша и возвращают их.{' '}
    </p>
    <CopyBlock
      text={`const memoize = fn => {
  const cache = {};

  return (...args) => {
    const stringifiedArgs = JSON.stringify(args);

    if (cache[stringifiedArgs]) {
      return cache[stringifiedArgs];
    }

    cache[stringifiedArgs] = fn(...args);

    return cache[stringifiedArgs];
  };
};`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <ul className={styles.list}>
      <li className={styles.list__item}>
        Для того, чтобы функцию можно было подвергнуть мемоизации, она должна быть чистой.
      </li>
      <li className={styles.list__item}>Мемоизация это компромисс между производительностью и потреблением памяти.</li>
      <li className={styles.list__item}>
        Применять мемоизацию при обращениях к API не стоит, браузер автоматически кэширует HTTP-запросы.
      </li>
      <li className={styles.list__item}>
        Лучше всего функции с мемоизацией показывают себя там, где выполняются сложные, ресурсоёмкие вычисления.
      </li>
    </ul>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>2.1 - Дополнительные материалы</h3>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <a className={styles.link} href="https://habrahabr.ru/company/ruvds/blog/332384/" target="_blank">
            Мемоизация в JS и ускорение функций
          </a>
        </li>
        <li className={styles.list__item}>
          <a className={styles.link} href="https://www.npmjs.com/package/memoizee" target="_blank">
            npm-пакет memoizee
          </a>
        </li>
      </ul>
    </section>
  </section>
))
